module.exports = __webpack_public_path__ + "img/app.a8af23ab.png";